import clsx from "clsx"

interface Props {
  children: React.ReactNode
  className?: string
}

export const PageMaxWidth: React.FC<Props> = ({ children, className }) => {
  return <div className={clsx("mx-auto flex w-full max-w-xl flex-col", className)}>{children}</div>
}
